import React from 'react';

import NestedLink from 'components/NestedLink';
import SearchInput from 'components/SearchInput';

import './style.scss';

const SearchBar = () => {
  return (
    <div className="SearchBar">
      <div className="SearchButton">
        <NestedLink to={'/search'} className="SearchInput">
          <SearchInput />
        </NestedLink>
      </div>
    </div>
  );
};

export default SearchBar;
